import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Row,
  Pagination,
  Popover,
  notification,
  Tag,
} from "antd";
import dayjs from "dayjs";
import SearchDatePickerInvoice from "components/search/datePickerInvoice";
import moneyFormat from "../../functions/utils/moneyFormat";
import { EyeFilled } from "@ant-design/icons";
import GetMerchantVatHistory from "../../functions/merchant/getMerchantVatHistory";
import { useLoading } from "../../context/loadingContext";
import ReCreateFailedVat from "functions/invoice/reCreateVat";
import { getMerchantId } from "service/storage";

const MerchantVatHistory = () => {
  const { showLoading, hideLoading } = useLoading();
  const [data, setData] = useState([]);
  const [query, setQuery] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});

  const search = async (queryObject) => {
    const queryString = Object.keys(queryObject)
      .map((key) => {
        if (!queryObject[key]) return;
        if (key.includes("At")) {
          // it is date range
          return `${key}=${queryObject[key]
            .map((e, i) => {
              if (i === 0)
                return dayjs(e).startOf("day").format("YYYY-MM-DD HH:mm");
              return dayjs(e).endOf("day").format("YYYY-MM-DD HH:mm");
            })
            .join("->")}`;
        }
        return `${key}=${encodeURIComponent(queryObject[key])}`;
      })
      .join("&");
    setQuery(queryObject);
    fetchVatHistories(queryString, page, pageSize);
  };

  const reCreateVat = async (id) => {
    showLoading();
    const result = await ReCreateFailedVat(id);
    console.log(result);
    if (result && result.data && result.data.status !== "FAILED")
      fetchVatHistories("", page, pageSize);
    else notification.error({ message: "Амжилтгүй боллоо." });
    hideLoading();
  };
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 40,
      className: "text-xs",
    },
    {
      title: "Нийт дүн",
      dataIndex: "requestData",
      key: "requestData",
      width: 100,
      render: (data) => moneyFormat(data.amount),
      className: "text-xs",
    },
    {
      title: "Хүсэлтийн JSON",
      dataIndex: "requestData",
      key: "requestDataJson",
      width: 80,
      align: "center",
      render: (data) => (
        <Popover
          content={JSON.stringify(data)}
          title="Хүсэлтийн JSON"
          trigger="click"
        >
          <Button
            size="small"
            type="primary"
            shape="circle"
            icon={<EyeFilled />}
          />
        </Popover>
      ),
    },
    {
      title: "НӨАТ JSON",
      dataIndex: "qrJson",
      key: "qrJson",
      width: 80,
      align: "center",
      render: (data) => (
        <Popover
          content={JSON.stringify(data)}
          title="НӨАТ JSON"
          trigger="click"
        >
          <Button
            size="small"
            type="primary"
            shape="circle"
            icon={<EyeFilled />}
          />
        </Popover>
      ),
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      width: 20,
      className: "text-xs",
      render: (e) => {
        if (e === "DONE") return <Tag color="success">{"Амжилттай"}</Tag>;
        if (e === "FAILED")
          return <Tag className="text-red-600 font-bold">{"Алдаатай"}</Tag>;
        if (e === "VAT_CREATED")
          return <Tag className="text-blue-600">{"Төлөлт хиигдээгүй"}</Tag>;
        return <Tag>{e}</Tag>;
      },
    },
    {
      title: "IP хаяг",
      dataIndex: "ip",
      key: "ip",
      width: 100,
      className: "text-xs",
    },
    {
      title: (
        <SearchDatePickerInvoice
          query={query}
          title="Үүссэн огноо"
          datePicker
          fieldName="createdAt"
          search={search}
        />
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD") : "-"),
      className: "text-xs",
    },
    {
      title: "Үйлдэл",
      dataIndex: "id",
      key: "id",
      width: 30,
      render: (e, r) => (
        <div>
          <Button
            onClick={() => reCreateVat(e)}
            disabled={r.status !== "FAILED"}
          >
            Нөхөж үүсгэх
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    refresh();
  }, []);

  const fetchVatHistories = async (queryString, page, size) => {
    showLoading();
    const merchantId = getMerchantId();
    const response = await GetMerchantVatHistory(
      merchantId,
      `&page=${page}&size=${size}&${queryString}`
    );
    hideLoading();
    if (response) {
      setData(response.data);
      setPaginationData(response.pagination);
    }
  };

  const changePage = (page) => {
    setPage(page);
    fetchVatHistories("", page, pageSize);
  };

  const changeSize = (current, size) => {
    setPageSize(size);
    fetchVatHistories("", current, size);
  };

  const refresh = () => {
    setPage(1);
    setQuery({});
    fetchVatHistories("", 1, pageSize);
  };

  return (
    <div className="vatMerchantListontainer p-2">
      <Row className="mb-2">
        {/* Add buttons or other controls here if needed */}
      </Row>
      <div className="tableContainer overflow-auto">
        <Table
          size="small"
          columns={columns}
          rowKey={(record) => record.id}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 38vh)",
          }}
          pagination={false}
          dataSource={data}
          className="text-xs"
          bordered
        />
        <Pagination
          size="small"
          total={paginationData.total}
          showTotal={(total) => `Нийт ${total} бичлэг`}
          defaultPageSize={pageSize}
          pageSize={paginationData.size}
          onChange={changePage}
          current={page}
          onShowSizeChange={changeSize}
          showSizeChanger
          className="mt-2 text-xs"
        />
      </div>
    </div>
  );
};

export default MerchantVatHistory;
